module.exports = __webpack_public_path__ + "static/media/pobl2.e120502a.jpg";